import BaseController from 'app/src/controllers/base/BaseController';
import SaleManager from 'app/src/payments/SaleManager';

export default class BasePaymentController extends BaseController {
  constructor(saleManager) {
    super();

    if (!(saleManager instanceof SaleManager)) {
      throw `A SaleManager must be specified when constructing a ${this.constructor.name}`;
    }

    this._saleManager = saleManager;
  }
}
